// 一覧項目設定
export class GridConfiguration{
    private _gridCaptions : string[] = [];
    private _gridWidths : number[] = [];
    private _gridSlots : string[] = [];
    private _gridVisibles :boolean[] = [];
    private _gridRequireds :boolean[] = [];
    private _baseConfigurations:GridItemConfiguration[] = []; // 常に表示する基本項目
    private _gridItemConfigurations:GridItemConfiguration[] = []; // 基本項目+変動項目
    private _slotPrefix : string = 'grid'; // ListView の場合は grid, ListDialogの場合は col
    private _variablePosition : number = 0; // 変動項目を追加する位置

    public get gridCaptions(){ return this._gridCaptions; }
    public get gridWidths(){ return this._gridWidths; }
    public get gridSlots(){ return this._gridSlots; }
    public get gridVisibles() {return this._gridVisibles;}
    public get gridRequireds() {return this._gridRequireds;}
    public get gridItemConfigurations() { return this._gridItemConfigurations};
    public get baseConfigurations() { return this._baseConfigurations};
    public constructor(baseItems:GridItemConfiguration[], variablePosition:number, slotPrefix:string = 'grid'){
        this._slotPrefix = slotPrefix;
        this._baseConfigurations = baseItems;
        this._variablePosition = variablePosition;
    }

    // 一覧項目設定に可変項目を追加する
    public setVariableItems(variableItems:GridItemConfiguration[]){
        var firstItems = this._baseConfigurations.slice(0, this._variablePosition);
        var lastItems = this._baseConfigurations.slice(this._variablePosition);
        this._gridItemConfigurations = firstItems.concat(variableItems).concat(lastItems);
        this.updateGrid();
    }
    /**GridItemConfigurationを追加します */
    public setGridItems(...items: GridItemConfiguration[]){
        this._gridItemConfigurations.push(...items);
        this.updateGrid();
    }

    public setGridItemsFromCaptions(captions:string[],widths:number[]){

        var items = new Array();
        for(var i = 0; i<captions.length;i++)
        {
            items.push(new GridItemConfiguration(captions[i],widths[i]));
        }
        this.setGridItems(...items);
    }
    // 表示・非表示の設定を元に_gridSlotsを設定する
    private setGridSlots(index:number, slotNo:number){
        // 各項目のslotを設定し終えた場合は、_gridSlotsを設定する
        if(index >= this._gridItemConfigurations.length) {
            this._gridSlots = this._gridItemConfigurations.map(c=>c.Slot);
            return;
        }

        // 表示項目のslotを設定する
        if(this._gridItemConfigurations[index].IsVisible){
            this._gridItemConfigurations[index].Slot = this._slotPrefix + slotNo;
            slotNo++;
        }
        // 非表示項目のslotを設定する
        else{
            this._gridItemConfigurations[index].Slot = '';
        }

        // 次の項目のslotを設定する
        this.setGridSlots(index + 1, slotNo);
    }

    
    // 一覧の表示設定を更新する
    private updateGrid(){
        this._gridCaptions = this._gridItemConfigurations.filter(c=>c.IsVisible).map(c=>c.Caption);
        this._gridWidths = this._gridItemConfigurations.filter(c=>c.IsVisible).map(c=>c.Width);
        this._gridVisibles = this._gridItemConfigurations.filter(c=>c.IsVisible).map(c=>c.IsGridVisible);
        this._gridRequireds = this._gridItemConfigurations.filter(c=>c.IsVisible).map(c=>c.IsRequired);
        this.setGridSlots(0,0);
    }
}

// 一覧の一項目の設定
export class GridItemConfiguration{
    public Caption :string = "";
    public Width :number=150;
    public  Slot :string="";
    public IsVisible :boolean=true;
    public IsGridVisible : boolean = true;//グリッド側の表示制御設定
    public IsRequired : boolean = false;//必須表示項目
    public constructor(caption:string, width :number=150, isVisible:boolean=true,isGridVisible=true,isRequired:boolean=false){
        this.Caption = caption;
        this.Width = width;
        this.IsVisible = isVisible;
        this.IsGridVisible = isGridVisible;
        this.IsRequired = isRequired;
    }
    public required(){
        this.IsRequired = true;
        return this;
    }
}

/**明細タブフラグ */
export enum voucherTypes {
  SalesOrder,
  SalesOrderItem,
  SalesDelivery,
  SalesDeliveryItem,
  SalesInvoice,
  SalesCharge,
  SalesChargeItem,
  PurchaseOrder,
  PurchaseOrderItem,
  PurchaseDelivery,
  PurchaseDeliveryItem,  
  PurchaseCharge,
  PurchaseChargeItem,
  //商品マスタタブ
  CommodityPrice,
  CommoditySKU,
  CommodityConversion,
  CommodityShelfNo,
  //在庫明細タブ
  StockRelocationItem,
  StockTakingItem,
  StockTransferItem,
  //セット品マスタの構成品タブ
  Component, 
  //ピッキング明細
  PickingItem,
  //案件一覧
  ProjectItem,
  //在庫一覧
  StockBalance,
}

export enum visibleTypes {
  None,
  ReadOnly,
  Editable
}